const SLUGS = {
  index: {
    title_fr: 'Accueil',
    title_en: 'Home',
    title_it: 'Casa Affitto',
    title_de: 'Ferienhaus',
    fr: '/',
    en: 'rental-villas-south-corsica',
    it: 'affitto-corsica-del-sud',
    de: 'ferienhaus-sudkorsika'
  },
  situation: {
    title_fr: 'Situation',
    title_en: 'Location',
    title_it: 'Posizione',
    title_de: 'Lage',
    fr: 'location-porto-vecchio/situation.php',
    en: 'rental-villas-south-corsica/location.php',
    it: 'affitto-corsica-del-sud/posizione.php',
    de: 'ferienhaus-sudkorsika/lage.php'
  },
  villas_t3: {
    title_fr: 'Villas T3',
    title_en: 'Villas T3',
    title_it: 'Villette T3',
    title_de: 'Villen T3',
    fr: 'location-porto-vecchio/villasT3.php',
    en: 'rental-villas-south-corsica/villasT3.php',
    it: 'affitto-corsica-del-sud/villetteT3.php',
    de: 'ferienhaus-sudkorsika/villenT3.php'
  },
  villa_t4: {
    title_fr: 'Villa T4',
    title_en: 'villa T4',
    title_it: 'Villette T4',
    title_de: 'Villen T4',
    fr: 'location-porto-vecchio/villaT4.php',
    en: 'rental-villas-south-corsica/villaT4.php',
    it: 'affitto-corsica-del-sud/villetteT4.php',
    de: 'ferienhaus-sudkorsika/villenT4.php'
  },
  tarifs: {
    title_fr: 'Tarifs',
    title_en: 'Rates',
    title_it: 'Tariffa',
    title_de: 'Tarife',
    fr: 'location-porto-vecchio/tarifs.php',
    en: 'rental-villas-south-corsica/rates.php',
    it: 'affitto-corsica-del-sud/tariffa.php',
    de: 'ferienhaus-sudkorsika/tarife.php'
  },
  photos: {
    title_fr: 'Photos',
    title_en: 'Pics',
    title_it: 'Le Foto',
    title_de: 'Bilder',
    fr: 'location-porto-vecchio/photos.php',
    en: 'rental-villas-south-corsica/pics.php',
    it: 'affitto-corsica-del-sud/le-foto.php',
    de: 'ferienhaus-sudkorsika/bilder.php'
  },
  contact: {
    title_fr: 'Contact',
    title_en: 'Contact',
    title_it: 'Contatto',
    title_de: 'Kontakt',
    fr: 'location-porto-vecchio/contact.php',
    en: 'rental-villas-south-corsica/contact.php',
    it: 'affitto-corsica-del-sud/contatto.php',
    de: 'ferienhaus-sudkorsika/kontakt.php'
  }
}

function getPageInfos(page, lang, type) {
  const pageInfos = SLUGS[page];
  let valueName = type === 'title'
    ? `title_${lang.toLowerCase()}`
    : lang.toLowerCase();
  return pageInfos[valueName];
}

function getPageSlug(page, lang) {
  return getPageInfos(page, lang, 'slug');
}

function getPageTitle(page, lang) {
  return getPageInfos(page, lang, 'title');
}

exports.getPageSlug = getPageSlug
exports.getPageTitle = getPageTitle
exports.SLUGS = SLUGS